import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth.jsx";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ConciergeWidget from "@/components/ConciergeWidget";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Experiences from "@/pages/Experiences";
import ExperienceDetail from "@/pages/ExperienceDetail";
import Directory from "@/pages/Directory";
import BusinessDetail from "@/pages/BusinessDetail";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import Concierge from "@/pages/Concierge";
import TripPlanner from "@/pages/TripPlanner";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import SubmitListing from "@/pages/SubmitListing";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function AppShell() {
  const location = useLocation();
  // Detect Google OAuth callback via URL hash synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const hideConcierge = ["/login", "/register"].includes(location.pathname);
  return (
    <>
      <Navbar />
      <main className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:slug" element={<EventDetail />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/experiences/:slug" element={<ExperienceDetail />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/directory/:slug" element={<BusinessDetail />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/:slug" element={<GuideDetail />} />
          <Route path="/concierge" element={<Concierge />} />
          <Route path="/trip-planner" element={<TripPlanner />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/submit/:token" element={<SubmitListing />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </main>
      <Footer />
      {!hideConcierge && <ConciergeWidget />}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppShell />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "var(--forest)",
              color: "var(--bone)",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "9999px",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
